export default {
  id: "calcon",
  name: "CalCon Mutual",
};
